export default __webpack_public_path__ + "static/media/hotel_soon_responcive.aa1af0c4.webp";